import React, { Component } from "react";
import { connect } from "react-redux";

import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

// import * as actions from "../../../store/actions";
// Wire up your real report actions here, e.g.:
// import { fetchReportSummary, fetchReportUsers } from "../../../store/actions";

// Brand colors that aren't part of the default PrimeReact theme.
const BRAND_NAVY = "#1e2a52";
const BRAND_ORANGE = "#e2551c";

// Plain style objects — these render identically no matter what version
// of PrimeReact/PrimeFlex is installed, since they don't depend on any
// utility class names resolving correctly.
const styles = {
  page: { padding: "24px 28px", maxWidth: 1200 },
  filterRow: {
    display: "flex",
    alignItems: "flex-end",
    flexWrap: "wrap",
    gap: 20,
    marginBottom: 16,
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: 6,
  },
  label: {
    fontWeight: 700,
    fontSize: "0.95rem",
    color: BRAND_NAVY,
  },
  dropdown: { minWidth: 220 },
  dateInput: { minWidth: 200, height: 42 },
  navyButton: { background: BRAND_NAVY, borderColor: BRAND_NAVY },
  heading: {
    color: BRAND_ORANGE,
    fontWeight: 700,
    fontSize: "1.15rem",
    textTransform: "uppercase",
    letterSpacing: "0.02em",
    margin: "32px 0 14px",
  },
  headingFirst: {
    color: BRAND_ORANGE,
    fontWeight: 700,
    fontSize: "1.15rem",
    textTransform: "uppercase",
    letterSpacing: "0.02em",
    margin: "0 0 14px",
  },
  summaryRow: { display: "flex", gap: 24, flexWrap: "wrap", marginBottom: 20 },
  summaryTable: { flex: 1, minWidth: 320 },
  covers: {
    display: "inline-flex",
    alignItems: "center",
    gap: 16,
    border: "1px solid #d9dee6",
    borderRadius: 4,
    background: "#fff",
    padding: "14px 20px",
    minWidth: 320,
    marginTop: 12,
  },
};

class Reports extends Component {
  constructor(props) {
    super(props);

    const today = new Date().toISOString().slice(0, 10);

    this.state = {
      selectedUser: null,
      fromDate: today,
      toDate: today,
      selectedReportType: null,

      summary: {
        amount: 0,
        serviceCharges: 0,
        totalSale: 0,
      },

      transactionRows: [
        { label: "Sale", cash: 0, gpay: 0, paytm: 0, phonepay: 0, total: 0 },
        { label: "Out Transactions", cash: 0, gpay: 0, paytm: 0, phonepay: 0, total: 0 },
        { label: "Total", cash: 0, gpay: 0, paytm: 0, phonepay: 0, total: 0 },
      ],

      totalCovers: "",
    };
  }

  componentDidMount() {
    // this.props.onFetchReportUsers();
    this.fetchReportData();
  }

  fetchReportData = () => {
    // this.props.onFetchReportSummary({
    //   userId: this.state.selectedUser,
    //   fromDate: this.state.fromDate,
    //   toDate: this.state.toDate,
    // });
  };

  onUserChange = (e) => this.setState({ selectedUser: e.value });
  onReportTypeChange = (e) => this.setState({ selectedReportType: e.value });
  onFromDateChange = (e) => this.setState({ fromDate: e.target.value });
  onToDateChange = (e) => this.setState({ toDate: e.target.value });
  onSearchClick = () => this.fetchReportData();
  onThermalPrintClick = () => {
    // hook up thermal print logic / API call here
  };
  onDayReportPrintClick = () => {
    // hook up day-report print logic / API call here
  };

  currencyBody = (field) => (row) => (Number(row[field]) || 0).toFixed(2);

  totalRowStyle = (row) =>
    row.label === "Total" ? { fontWeight: 700 } : {};

  render() {
    const {
      selectedUser,
      fromDate,
      toDate,
      selectedReportType,
      summary,
      transactionRows,
      totalCovers,
    } = this.state;

    const userOptions = this.props.userList || [];
    const reportOptions = this.props.reportTypeList || [];

    return (
      <div style={styles.page}>

        {/* ── Filters ─────────────────────────────────────────────────── */}
        <div style={styles.filterRow}>
          <div style={styles.field}>
            <label style={styles.label}>User</label>
            <Dropdown
              value={selectedUser}
              options={userOptions}
              onChange={this.onUserChange}
              placeholder="Select User"
              style={styles.dropdown}
              showClear
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>From</label>
            <input
              type="date"
              className="p-inputtext p-component"
              style={styles.dateInput}
              value={fromDate}
              onChange={this.onFromDateChange}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>To</label>
            <input
              type="date"
              className="p-inputtext p-component"
              style={styles.dateInput}
              value={toDate}
              onChange={this.onToDateChange}
            />
          </div>

          <Button label="Search" style={styles.navyButton} onClick={this.onSearchClick} />
        </div>

        <div style={styles.filterRow}>
          <div style={styles.field}>
            <label style={styles.label}>Print</label>
            <Dropdown
              value={selectedReportType}
              options={reportOptions}
              onChange={this.onReportTypeChange}
              placeholder="Select Report"
              style={styles.dropdown}
              showClear
            />
          </div>

          <Button label="Thermal Print" style={styles.navyButton} onClick={this.onThermalPrintClick} />
          <Button label="Day Report Print" style={styles.navyButton} onClick={this.onDayReportPrintClick} />
        </div>

        {/* ── Today's Summary ─────────────────────────────────────────── */}
        <h3 style={styles.headingFirst}>Todays Summary</h3>

        <div style={styles.summaryRow}>
          <DataTable
            value={[
              { label: "Amount", value: summary.amount },
              { label: "Service Charges", value: summary.serviceCharges },
              { label: "Total Sale", value: summary.totalSale },
            ]}
            showGridlines
            style={styles.summaryTable}
          >
            <Column field="label" header="" body={(r) => <span style={{ fontWeight: 700 }}>{r.label}</span>} />
            <Column field="value" header="" body={(r) => (Number(r.value) || 0).toFixed(2)} align="right" />
          </DataTable>

          <DataTable
            value={[{ label: "Total Sale", value: summary.totalSale }]}
            showGridlines
            style={styles.summaryTable}
          >
            <Column field="label" header="" body={(r) => <span style={{ fontWeight: 700 }}>{r.label}</span>} />
            <Column field="value" header="" body={(r) => (Number(r.value) || 0).toFixed(2)} align="right" />
          </DataTable>
        </div>

        {/* ── Overall Transactions ───────────────────────────────────── */}
        <h3 style={styles.heading}>Overall Transactions</h3>

        <DataTable value={transactionRows} showGridlines rowStyle={this.totalRowStyle} style={{ marginBottom: 20 }}>
          <Column field="label" header="" body={(r) => <span style={{ fontWeight: 700 }}>{r.label}</span>} />
          <Column field="cash" header="CASH" body={this.currencyBody("cash")} align="right" />
          <Column field="gpay" header="G Pay" body={this.currencyBody("gpay")} align="right" />
          <Column field="paytm" header="PAYTM" body={this.currencyBody("paytm")} align="right" />
          <Column field="phonepay" header="PhonePay" body={this.currencyBody("phonepay")} align="right" />
          <Column field="total" header="Total" body={this.currencyBody("total")} align="right" />
        </DataTable>

        {/* ── Total Covers ────────────────────────────────────────────── */}
        <div style={styles.covers}>
          <span style={{ fontWeight: 700 }}>Total No. Of Covers</span>
          <span style={{ marginLeft: "auto" }}>{totalCovers}</span>
        </div>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // userList: state.report.userList,
  // reportTypeList: state.report.reportTypeList,
  // loading: state.report.loading,
  // error: state.report.error,
});

const mapDispatchToProps = (dispatch) => ({
  // onFetchReportUsers: () => dispatch(actions.fetchReportUsers()),
  // onFetchReportSummary: (params) => dispatch(actions.fetchReportSummary(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);